/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface BilanCompetenceFichierUploadDto
 */
export interface BilanCompetenceFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof BilanCompetenceFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof BilanCompetenceFichierUploadDto
     */
    idbilanCompetenceFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof BilanCompetenceFichierUploadDto
     */
    idbilanCompetence?: number;
    /**
     * 
     * @type {number}
     * @memberof BilanCompetenceFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof BilanCompetenceFichierUploadDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof BilanCompetenceFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the BilanCompetenceFichierUploadDto interface.
 */
export function instanceOfBilanCompetenceFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BilanCompetenceFichierUploadDtoFromJSON(json: any): BilanCompetenceFichierUploadDto {
    return BilanCompetenceFichierUploadDtoFromJSONTyped(json, false);
}

export function BilanCompetenceFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BilanCompetenceFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'idbilanCompetenceFichier': !exists(json, 'idbilanCompetenceFichier') ? undefined : json['idbilanCompetenceFichier'],
        'idbilanCompetence': !exists(json, 'idbilanCompetence') ? undefined : json['idbilanCompetence'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function BilanCompetenceFichierUploadDtoToJSON(value?: BilanCompetenceFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'idbilanCompetenceFichier': value.idbilanCompetenceFichier,
        'idbilanCompetence': value.idbilanCompetence,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

